export class OfferPrice {
  constructor(
    public amount: number,
    public calculationPeriod: {
      validFrom: Date,
      validUntil: Date
    },
    public currency: string,
    public price: number,
    public priceText: string,
    public trial: boolean,
    public porto: number,
    public portoDescription: string,
    public credit?: number
  ) {
  }
}
